import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./WorkingGroups.css";

const committees = [
  {
    name: "Education & Standards Committee",
    chair: "Dr. Frank Odoom",
    image: "/images/frank_odoom.jpg",
    members: [
      "Stephen Yeboah",
      "Dr. Kojo Essel Menah",
      "Dr. Emmanuel Thompson",
      "Harris Yemoh",
      "Kwame Gazo Agbenyazi",
      "Mark Larbi Henaku",
    ],
    document: "/Working-Group/pensions_benefits.pdf",
  },
  {
    name: "Pensions, Benefits & Social Security Committee",
    chair: "Ernest Amartey Vondee",
    image: "/images/ernest_vondee.jpg",
    members: [
      "Neil Tagoe",
      "Edward Aidoo-Mensah",
      "Evelyn Adjei",
      "Theophilus Afenya",
      "Joseph Poku",
    ],
    document: "/Working-Group/pensions_benefits.pdf",
  },
  {
    name: "Life & Microinsurance Committee",
    chair: "Albert Amonoo-Mensah",
    image: "/images/ernest_vondee.jpg",
    members: [
      "Isaac Senior Damptey",
      "Francis Gota",
      "Richard Okyere",
      "Albert Oko Dagadu",
      "Eric Ansah Gyan",
      "Kwame Twumasi",
    ],
    document: "/Working-Group/pensions_benefits.pdf",
  },
  {
    name: "Enterprise & Financial Risk",
    chair: "Christopher Kobia Amanfi",
    image: "/images/ernest_vondee.jpg",
    members: [
      "Harris Yemoh",
      "Kakra Duffuor-Nyarko",
      "Clifford Mensah",
      "David Abbey",
    ],
    document: "/Working-Group/pensions_benefits.pdf",
  },
  {
    name: "Non-Life (Health & GI) Working Group",
    chair: "Magnus Owusu-Agyemang",
    image: "/images/ernest_vondee.jpg",
    members: [
      "Ortopah Kojo Botchey",
      "Selorm Kofi Domeh",
      "Menyikoba Boadi",
      "Charles Adjei-Mensah",
      "Hagar Opoku-Ageymang",
      "Albert Adaare",
      "George Adjei-Nuertey",
    ],
    document: "/Working-Group/pensions_benefits.pdf",
  },
];

const WorkingGroups = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleDropdown = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <section className="section-aboutasg">
        <div className="sectiontop-line"></div>
        <h2 className="sectiontitle">WORKING GROUPS</h2>
        <div className="sectionbottom-line"></div>
      </section>
      <div className="main-container">
      <section className="university-section" style={{backgroundColor: "white"}} >
      <div className="working-groups-container">
        {committees.map((committee, index) => (
          <div key={index} className="committee-section">
            <div className="committee-header" onClick={() => toggleDropdown(index)}>
              <h2>{committee.name}</h2>
              <span className="dropdown-icon">{activeIndex === index ? "▲" : "▼"}</span>
            </div>
            {activeIndex === index && (
              <div className="committee-content">
                <img src={committee.image} alt={committee.chair} className="chair-image" />
                <p className="chair-name">
                  {committee.chair} <span>- Chair</span>
                </p>
                <h3>Members</h3>
                <ul>
                  {committee.members.map((member, i) => (
                    <li key={i}>{member}</li>
                  ))}
                </ul>
                <h3>Documents</h3>
                {/* Updated to navigate to the PDF viewer route */}
                <a
                  href={`/pdf-viewer/${encodeURIComponent(committee.document)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Reference
                </a>
              </div>
            )}
          </div>
        ))}
      </div>
      </section>
      <section className="card-section" style={{marginTop: '40px'}}>
        <Link to='/strategic-plan'>
          <div className="accreditation-card">
          <h2 className="uni-title">Strategic Plan </h2>
          </div>
        </Link>
        <Link>
          <div className="accreditation-card">
          <h2 className="uni-title">ASG Constitution</h2>
          </div>
        </Link>
        <Link to='/working-group'>
          <div className="accreditation-card">
          <h2 className="uni-title">Working Group</h2>
          </div>
        </Link>
    </section> 
      </div>
    </div>
  );
};

export default WorkingGroups;
